<template>
	<component
		:is="tag"
		:class="`client-only-wrapper client-only-wrapper--${type}`"
	>
		<div class="client-only-wrapper__content">
			<slot />
		</div>
	</component>
</template>

<script>
export default {
	name: 'ClientOnlyWrapper',

	computed: {
		tag() {
			return this.type === 'nuxt' ? 'client-only' : 'div';
		},

		type() {
			return this.$nuxt ? 'nuxt' : 'cli';
		},
	},
};
</script>
